import { Injectable } from '@angular/core';
import {
  EpimsGenderDto,
  StateDto,
  LgaDto,
  CountryDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  CourseOfStudyDto,
  ScholarshipSessionDto,
  CommunityDto,
  ScholarshipAwardDurationDto,
} from '@cradua/data';

@Injectable()
export class ScholarshipInfoService {
  constructor() {}

  genderName(genders: EpimsGenderDto[], value) {
    const foundGender = genders.find((gender) => gender.id === value);
    return foundGender && foundGender.GenderName;
  }

  stateName(states: StateDto[], value) {
    const foundState = states.find((state) => state.id === value);
    return foundState && foundState.StateName;
  }

  lgaName(lgas: LgaDto[], value) {
    const foundLga = lgas.find((lga) => lga.id === value);
    return foundLga && foundLga.LgaName;
  }

  countryName(countries: CountryDto[], value) {
    const foundCountry = countries.find((country) => country.id === value);
    return foundCountry && foundCountry.CountryName;
  }

  courseOfStudyName(courseOfStudy: CourseOfStudyDto[], value) {
    const foundCourseOfStudy = courseOfStudy.find(
      (course) => course.id === value
    );
    return foundCourseOfStudy && foundCourseOfStudy.CourseOfStudyName;
  }

  scholarshipTypeName(scholarshipType: ScholarshipTypeDto[], value) {
    const foundScholarshipType = scholarshipType.find(
      (type) => type.id === value
    );
    return foundScholarshipType && foundScholarshipType.ScholarshipTypeName;
  }

  scholarshipCategoryName(
    scholarshipCategory: ScholarshipCategoryDto[],
    value
  ) {
    const foundScholarshipCategory = scholarshipCategory.find(
      (category) => category.id === value
    );
    return (
      foundScholarshipCategory &&
      foundScholarshipCategory.ScholarshipCategoryName
    );
  }

  scholarshipAwardDurationName(
    scholarshipAwardDuration: ScholarshipAwardDurationDto[],
    value
  ) {
    const foundScholarshipAwardDuration = scholarshipAwardDuration.find(
      (award) => award.id === value
    );
    return (
      foundScholarshipAwardDuration &&
      foundScholarshipAwardDuration.ScholarshipAwardDurationName
    );
  }

  scholarshipSessionName(scholarshipSession: ScholarshipSessionDto[], value) {
    const foundScholarshipSession = scholarshipSession.find(
      (session) => session.id === value
    );
    return (
      foundScholarshipSession && foundScholarshipSession.ScholarshipSessionName
    );
  }

  communityName(communities: CommunityDto[], value) {
    const foundScholarshipCommunity = communities.find(
      (community) => community.id === value
    );
    return foundScholarshipCommunity && foundScholarshipCommunity.CommunityName;
  }
}
